import React from 'react';

import classNames from 'classnames/bind';
import style from './Title.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

const Title = props => (
  <Link to="/">
    <span className={ctx('title')}>Специальный проект Альфа Private</span>
  </Link>
);

export default Title;
